/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// NO DATA : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
    nodataview:{
        background: theme.color.supporting.light.swatch,
        width: '100%',
        // height: '80%',
        // minHeight: pxToEm(258),
        // height: '85%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '& .copy':{
            textAlign: 'center',
            fontSize: pxToEm(14),
            opacity: '1 !important',
            '& .title':{
                color: theme.color.primary.medium.swatch,
                margin: pxToEm(16)
            }
        }
    }
})